import type { SVGProps } from "react";
// generated from Image.svg — do not edit manually
// prettier-ignore
export default function Image(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 3 17 V 3 H 14 M 3 17 L 10 12 L 14 16 M 3 17 V 21 H 19 M 14 16 L 17.5 13.5 L 21 17 M 14 16 L 19 21 M 21 17 V 21 H 19 M 21 17 V 10 M 21 10 V 3 H 14 M 21 10 C 17.134 10 14 6.866 14 3" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
